import React from "react";
import {Dropdown, DropdownChangeEvent} from "primereact/dropdown";
import { useGetSupportedTimezones } from "api/api-hooks/user-hooks";
import { recordToSelectItems } from "utils/utils";
import {useUserState} from "store/user-store";
import {logInfo} from "utils/logging-utils";



export default function TimezoneSelectFragment() {
    const displayTimezone = useUserState((state) => state.getDisplayTimezone());
    const setDisplayTimezone = useUserState((state) => state.setDisplayTimezone);
    const companyTimezone = useUserState((state) => state.getCompanyTimezone());
    const setCompanyTimezone = useUserState((state) => state.setCompanyTimezone);

    const tzSelectData = useGetSupportedTimezones()
    const timezoneSelections = recordToSelectItems(tzSelectData.data)

    logInfo("display tz ", displayTimezone);
    logInfo("company tz ", companyTimezone);


    const onDisplayTzChange = (e: DropdownChangeEvent) => {
        logInfo("Setting display timezone to ", e.value);
        setDisplayTimezone(e.value);
    }

    const onCompanyTzChange = (e: DropdownChangeEvent) => {
        logInfo("Setting company timezone to ", e.value);
        setCompanyTimezone(e.value);
    }

    if(!timezoneSelections) {
        return <div>Loading timezones...</div>
    }

    return <div>
      D:<Dropdown placeholder="Select Display Timezone"
        value={displayTimezone}
        options={timezoneSelections}
        filter
        filterMatchMode="contains"
        onChange={onDisplayTzChange}
        optionValue="value"
    />
    C:<Dropdown placeholder="Select Company Timezone"
        value={companyTimezone}
        options={timezoneSelections}
        filter
        filterMatchMode="contains"
        onChange={onCompanyTzChange}
        optionValue="value"
    />
    </div>
}